// extracted by mini-css-extract-plugin
export var DocsHeading = "styles-module--DocsHeading--3cPYE";
export var leadParagraph = "styles-module--leadParagraph--3rQTy";
export var DocsWrapper = "styles-module--DocsWrapper--2LApe";
export var docsPage = "styles-module--docsPage--25Vj2";
export var Docs = "styles-module--Docs--2W-S2";
export var docsInline = "styles-module--docsInline--LQlFY";